import { Fragment } from 'react'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import PlanMenuTableRow from './plan-menu-table-row'
import {
  PlanMenuFolderStatusRow,
  PlanMenuTableStatusRow
} from './plan-menu-table-status-row'
import {
  NotFoundContainerBody,
  NotFoundContainerCell,
  NotFoundContainerContent,
  NotFoundContainerRow
} from '../../../styled-component'
import NotFoundComponent from '../../../../../components/stories/molecules/not-found'
import { Plan } from '../../../../../components/stories/atoms/icons/entities'
import colorsOptions from '../../../../../components/stories/fundamentals/colors-styles/constants'
import ButtonComponent from '../../../../../components/stories/atoms/button'
import { buttonVariantOptions } from '../../../../../components/stories/atoms/button/constants'
import { textStyleSizeOptions } from '../../../../../components/stories/fundamentals/text-styles/constants'

const PlanMenuTableBody = ({
  canCreatePlans,
  childrenByFolderId,
  folderChildrenStateById,
  formatMessage,
  isError,
  movingItemIds = [],
  onCreatePlan,
  rowSelection,
  rowsById,
  table,
  search
}) => {
  const allVisibleRows = table.getRowModel().rows
  const seenRowIds = new Set()
  const visibleRows = allVisibleRows.filter((row) => {
    if (seenRowIds.has(row.id)) return false
    seenRowIds.add(row.id)
    return true
  })
  const visibleRowIds = visibleRows.map((row) => row.id)
  const colSpan = table.getAllColumns().length

  if (isError) {
    return (
      <tbody>
        <PlanMenuTableStatusRow colSpan={colSpan}>
          {formatMessage({
            id: 'common_errors_list-load',
            defaultMessage: 'Unable to load plans'
          })}
        </PlanMenuTableStatusRow>
      </tbody>
    )
  }

  const description = canCreatePlans
    ? 'plans_overview_empty-state_description'
    : 'plans_overview_empty-state_description_restricted'

  if (!visibleRows.length) {
    return (
      <NotFoundContainerBody>
        <NotFoundContainerRow>
          <NotFoundContainerCell colSpan={colSpan}>
            <NotFoundContainerContent>
              {search ? (
                <NotFoundComponent
                  header={formatMessage({ id: 'pinList_noResult' })}
                  headerSize={textStyleSizeOptions['TEXT-XXL']}
                  description={formatMessage({ id: 'not_found_description' })}
                  descriptionSize={textStyleSizeOptions['TEXT-L']}
                />
              ) : (
                <>
                  <NotFoundComponent
                    icon={
                      <Plan
                        stroke={colorsOptions.greys['grey-50']}
                        style={{
                          width: '144px',
                          height: '144px'
                        }}
                      />
                    }
                    header={formatMessage({
                      id: 'plans_overview_empty-state_title'
                    })}
                    headerSize={textStyleSizeOptions['TEXT-XXL']}
                    description={formatMessage({
                      id: description
                    })}
                    descriptionSize={textStyleSizeOptions['TEXT-L']}
                    style={{ maxWidth: '432px' }}
                  />
                  {canCreatePlans && (
                    <ButtonComponent
                      variant={buttonVariantOptions.PRIMARY}
                      onClick={onCreatePlan}
                    >
                      {formatMessage({ id: 'plans_action_import' })}
                    </ButtonComponent>
                  )}
                </>
              )}
            </NotFoundContainerContent>
          </NotFoundContainerCell>
        </NotFoundContainerRow>
      </NotFoundContainerBody>
    )
  }

  const isRowSelected = (id) => !!rowSelection?.[id]

  return (
    <tbody>
      <SortableContext
        items={visibleRowIds}
        strategy={verticalListSortingStrategy}
      >
        {visibleRows.map((row) => (
          <Fragment key={row.id}>
            <PlanMenuTableRow
              isSelected={isRowSelected(row.id)}
              isMoving={movingItemIds.includes(String(row.id))}
              row={row}
              rowSelection={rowSelection}
              rowsById={rowsById}
            />
            <PlanMenuFolderStatusRow
              childrenByFolderId={childrenByFolderId}
              colSpan={colSpan}
              folderChildrenStateById={folderChildrenStateById}
              formatMessage={formatMessage}
              row={row}
            />
          </Fragment>
        ))}
      </SortableContext>
    </tbody>
  )
}

export default PlanMenuTableBody
